export default "__VITE_ASSET__UZYDAGRJ__"